import Vue from 'vue';
import Registration from "./pages/Registration";
import DigitalMenu from "./pages/DigitalMenu";
import {VueReCaptcha} from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, {
    siteKey: process.env.MIX_RECAPTCHA_SMARTMENU_REGISTRATION,
    loaderOptions: {
        autoHideBadge: true
    }
})

Vue.component('cp-smart-menu-registration', Registration);
Vue.component('cp-smart-menu-digitalmenu', DigitalMenu);
